import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
import anilSeat from './anil-seat.vue';
import { getListByItemId, generateSeat, changeSeatStatus, changeAreaStatus } from "@/api/PMS/performancecenter/seat";
import { fetchList } from "@/api/PMS/performancecenter/theaterAreaPrice";
export default {
  name: 'ComplexTable',
  components: {
    anilSeat: anilSeat
  },
  props: ['keyValue', 'showDialog', 'theaterId', 'activityAuditStatus'],
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.listQuery = {
          actiItemId: ''
        };
        this.getList();
      }
    }
  },
  data: function data() {
    return {
      seatData: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        actiItemId: ''
      },
      title: '',
      Id: -1,
      multipleSelection: [],
      statusList: []
    };
  },
  computed: {
    showEdit: function showEdit() {
      if (this.activityAuditStatus == 0) {
        return true;
      }

      return false;
    }
  },
  created: function created() {
    this.getList();
    this.getList1();
  },
  methods: {
    getList1: function getList1() {
      var _this = this;

      var params = {
        activityItemId: this.keyValue
      };
      fetchList(params).then(function (response) {
        _this.statusList = response.data.data.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            areaType: 0
          });
        });
      });
    },
    createSeat: function createSeat(item) {
      this.getFloorList(item);
    },
    seatStatus: function seatStatus(item) {
      if (item.type == 'seat') {
        this.getSeatStatusList(item);
      } else if (item.type == 'area') {
        this.getAreaStatusList(item);
      }
    },
    getFloorList: function getFloorList(item) {
      var _this2 = this;

      var params = {
        actiItemId: this.keyValue,
        type: item.type
      };
      generateSeat(params).then(function (response) {
        _this2.getList();
      });
    },
    getSeatStatusList: function getSeatStatusList(item) {
      var _this3 = this;

      changeSeatStatus(item).then(function (response) {
        if (response.data.code == 200) {
          _this3.Alert({
            alertType: 'action'
          });

          _this3.getList();
        }
      });
    },
    getAreaStatusList: function getAreaStatusList(item) {
      var _this4 = this;

      changeAreaStatus(item).then(function (response) {
        if (response.data.code == 200) {
          _this4.Alert({
            alertType: 'action'
          });

          _this4.getList();
        }

        _this4.getList1();
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this5 = this;

      this.$set(this.listQuery, "actiItemId", this.keyValue);
      getListByItemId(this.listQuery).then(function (response) {
        _this5.seatData = response.data.data; // if (this.$refs.myseat) {
        //   this.$refs.myseat.seatData =  this.seatData  
        //   this.$refs.myseat.initData()
        //  }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(Id) {
      this.Id = Id;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(Ids) {
      var _this6 = this;

      if (Ids.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(Ids).then(function (response) {
            if (response.data.code == 200) {
              _this6.getList();

              _this6.Alert({
                alertType: 'delete'
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};